import React from 'react'
import '../../assets/css/loader.css';

const Spinner = (props) =>{

        return (
            <div class="lds-hourglass"></div>
            )
}
export default Spinner